import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import AnimatedSection from './AnimatedSection';

const MailingListSignup = ({ title, text, backgroundImage, icon }) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await addDoc(collection(db, 'subscribers'), {
        email: values.email,
        timestamp: new Date()
      });
      form.resetFields();
      message.success('Thanks for subscribing!');
    } catch (error) {
      console.error('Error adding subscriber:', error);
      message.error('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="section-with-bg mailing-list-section"
      style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none' }}
    >
      <div className="section-bg-overlay"></div>
      <div className="section-content-wrapper container mailing-list-content">
        <AnimatedSection className="w-full">
          {icon && (
            <div className="mailing-list-icon-container">
              {React.cloneElement(icon, { className: 'mailing-list-icon' })}
            </div>
          )}
          <h2 className="section-title">{title}</h2>
          <p className="section-subtitle">{text}</p>
          <Form
            form={form}
            onFinish={handleSubmit}
            className="mailing-list-form"
            layout="inline"
          >
            <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input email!' },
                { type: 'email', message: 'Invalid email!' }
              ]}
              style={{ flex: 1, marginBottom: 0 }}
            >
              <Input
                type="email"
                placeholder="Enter your email"
                size="large"
                disabled={isSubmitting}
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                disabled={isSubmitting}
                loading={isSubmitting}
              >
                {isSubmitting ? 'Joining…' : 'Join'}
              </Button>
            </Form.Item>
          </Form>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default MailingListSignup;